import { Typography } from "@mui/material";
import { CoreRadioGroup, RadioOption } from "../../../core";
import SubOptionLine from "../../images/subOptionLine.svg?react";
import { useId } from "react";

type RadioGroupSubItemProps = {
	radioOptions: RadioOption[];
	onChange: (event: React.ChangeEvent<HTMLInputElement>, value: string) => void;
	radioGroupDescription: string;
	selectedValue?: string;
};

export const RadioGroupSubItem = ({
	radioOptions,
	onChange,
	selectedValue,
	radioGroupDescription,
}: RadioGroupSubItemProps) => {
	const headerId = useId();
	return (
		<div
			style={{
				display: "flex",
				flexDirection: "row",
				gap: "5px",
				margin: "5px 0 5px 10px",
			}}
		>
			<SubOptionLine />
			<div style={{ display: "flex", flexDirection: "column" }}>
				<Typography fontSize={12} lineHeight={1.6} id={headerId}>
					{radioGroupDescription}
				</Typography>
				<CoreRadioGroup
					radioGroupAriaLabelledby={headerId}
					onChange={onChange}
					selectedValue={selectedValue}
					sx={{ marginLeft: "2px" }}
					radioOptions={radioOptions}
					radioLabelFontSize={12}
				/>
			</div>
		</div>
	);
};
